import {
    StyledContactsWrapper,
    StyledImg,
    StyledRequestAccessButton,
    StyledTitleWrapper,
    StyledSubTitleWrapper,
    ContentWrapper,
    StyledTitle,
    StyledSubTitle,
    StyledReachingWrapper,
    StyledReachingImg,
} from "./styles";
import {
    EXPORT_REQUEST_ACCESS_SUBTITLE,
    EXPORT_REQUEST_ACCESS_TITLE,
    NO_ACCESS_BTN,
    NO_ACCESS_SUB_TITLE,
    NO_ACCESS_TITLE,
} from "../../translations/translations";
import { useAccessRequestProps } from "../../hooks/useAccessRequestProps";
import {
    NO_ACCESS_IMG,
    MANAGEMENT_REACHING_OUT_IMG,
} from "app/pages/sales-intelligence/pages/management/constants/constants";
import { AssetsService } from "app/services/AssetsService";
import { ExportTable } from "../ExportTable/ExportTable";
import integrationTrackingService from "app/pages/sales-intelligence/services/tracking/integrationTrackingService";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { translate } from "app/filters/i18nFilter";

export const Contacts = () => {
    const { hasAccess, accessRequested, requestAccess } = useAccessRequestProps();
    const { integrationName } = getIntegrationNameFromUrl();

    const handleClick = () => {
        integrationTrackingService.trackRequestAccess(integrationName);
        requestAccess();
    };

    const renderRequestAccess = accessRequested ? (
        <StyledReachingWrapper>
            <StyledReachingImg
                src={AssetsService.assetUrl(MANAGEMENT_REACHING_OUT_IMG)}
                alt="request-access"
            />
            <StyledTitle>{translate(EXPORT_REQUEST_ACCESS_TITLE)}</StyledTitle>
            <StyledSubTitle>{translate(EXPORT_REQUEST_ACCESS_SUBTITLE)}</StyledSubTitle>
        </StyledReachingWrapper>
    ) : (
        <StyledImg src={NO_ACCESS_IMG}>
            <ContentWrapper>
                <StyledTitleWrapper>{translate(NO_ACCESS_TITLE)}</StyledTitleWrapper>
                <StyledSubTitleWrapper>{translate(NO_ACCESS_SUB_TITLE)}</StyledSubTitleWrapper>
                <StyledRequestAccessButton
                    onClick={handleClick}
                    type="primary"
                    buttonHtmlType="button"
                >
                    {translate(NO_ACCESS_BTN)}
                </StyledRequestAccessButton>
            </ContentWrapper>
        </StyledImg>
    );

    return (
        <StyledContactsWrapper>
            {hasAccess ? <ExportTable exportName="contacts" /> : renderRequestAccess}
        </StyledContactsWrapper>
    );
};
